import { render, staticRenderFns } from "./DropDownFullscreen.vue?vue&type=template&id=81ecfb8e&scoped=true&"
import script from "./DropDownFullscreen.vue?vue&type=script&lang=js&"
export * from "./DropDownFullscreen.vue?vue&type=script&lang=js&"
import style0 from "./DropDownFullscreen.vue?vue&type=style&index=0&id=81ecfb8e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81ecfb8e",
  null
  
)

export default component.exports